/**
 * Хранилище миграций в памяти для CSElement
 */

import { IMigrationStorage, MigrationRecord, MigrationStatus } from '../types/migration-interfaces';

/**
 * Реализация хранилища миграций в памяти
 */
export class MemoryMigrationStorage implements IMigrationStorage {
  private records: Map<string, MigrationRecord> = new Map();

  /**
   * Сохранение записи о миграции
   */
  async saveRecord(record: MigrationRecord): Promise<void> {
    this.records.set(record.migrationId, { ...record });
  }

  /**
   * Получение записи о миграции
   */
  async getRecord(migrationId: string): Promise<MigrationRecord | undefined> {
    const record = this.records.get(migrationId);
    return record ? { ...record } : undefined;
  }

  /**
   * Получение всех записей
   */
  async getAllRecords(): Promise<MigrationRecord[]> {
    return Array.from(this.records.values()).map(record => ({ ...record }));
  }

  /**
   * Получение записей по статусу
   */
  async getRecordsByStatus(status: MigrationStatus): Promise<MigrationRecord[]> {
    return Array.from(this.records.values())
      .filter(record => record.status === status)
      .map(record => ({ ...record }));
  }

  /**
   * Обновление статуса миграции
   */
  async updateStatus(migrationId: string, status: MigrationStatus): Promise<void> {
    const record = this.records.get(migrationId);
    if (record) {
      record.status = status;
      this.records.set(migrationId, record);
    }
  }

  /**
   * Удаление записи
   */
  async deleteRecord(migrationId: string): Promise<void> {
    this.records.delete(migrationId);
  }

  /**
   * Очистка всех записей
   */
  async clear(): Promise<void> {
    this.records.clear();
  }
} 